import { http } from './http';


export async function listConclusions(params = {}) {
    const { data } = await http.get('book/conclusions/', { params });
    return data;
}


export async function getConclusion(id) {
    const { data } = await http.get(`book/conclusions/${id}/`);
    return data;
}


export async function createConclusion(payload) {
    
    const { data } = await http.post('book/conclusions/', payload);
    return data;
}


export async function updateConclusion(id, payload) {
    const { data } = await http.patch(`book/conclusions/${id}/`, payload);
    return data;
}


export async function deleteConclusion(id) {
    const { data } = await http.delete(`book/conclusions/${id}/`);
    return data;
}